import React, { Component } from 'react'

import style from './style.module.css'

class Modal extends Component {

    state = {
        type: null,
        overflowY: 'auto'
    }

    constructor(props) {
        super(props)
        this.hide = this.hide.bind(this)

        this.body = document.body || document.documentElement
    }

    ignoreClose(e) {
        e.stopPropagation()
    }

    fixBody() {
        this.body.style.overflowY = 'hidden'
    }

    unFixBody() {
        this.body.style.overflowY = this.state.overflowY
    }

    componentDidMount() {
        this.eventListener = function(evt) {
            var keyCode = evt.keyCode ? evt.keyCode :
                evt.charCode ? evt.charCode :
                evt.which ? evt.which : void 0
            if (keyCode === 27) {
                this.hide()
                evt.stopPropagation()
                evt.preventDefault()
            }
        }.bind(this)

        window.addEventListener('keydown', this.eventListener)
    }

    componentWillUnmount(){
        this.unFixBody()
        window.removeEventListener('keydown', this.eventListener)
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props)
    }

    componentWillReceiveProps(nextProps) {
        var overflowY = this.body.style.overflowY
        if(nextProps.active && overflowY !== 'hidden') {
            this.fixBody()
            this.setState({
                type: 'controlled',
                overflowY
            })
        }

        if(this.state.type === 'controlled' && !nextProps.active) {
            this.unFixBody()
        }
    }

    hide(e) {
        if(this.props.handleClose) this.props.handleClose()
        if(e)
        e.stopPropagation()
    }

    render() {
        if(!this.props.active) return null


        return (
            <div ref='scrollable'
                onScroll={(event) => {
                    this.props.handleScroll && this.props.handleScroll(event)
                }}
                className={`${style.background}
                ${this.props.active ? style.active : ''}`}
                onClick={this.hide}>

                <div className={`${style.modalContainer} ${this.props.full ? style.full : ''}`} onClick={this.hide}>

                    <div className={style.modalTable}>
                        <div className={style.modalCell}>

                            <div
                                className={style.modalContent}
                                style={this.props.style}
                                onClick={this.ignoreClose}
                                ref='content'
                            >
                                {!this.props.hideClose && (
                                    <div className={style.modalClose} onClick={this.hide}>&#215;</div>
                                )}
                                {(this.props.loadContent === undefined || this.props.loadContent) && (
                                    this.props.children
                                )}
                                <div style={{ clear: 'both' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Modal



// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Modal/index.js